import {
  LogoutRequest,
  PasswordResetRequest,
  UpdateField,
} from './../auth.actions'
import {
  getIsAuthenticatedState,
  getPasswordResetState,
} from './../auth.selectors'
import { ActivatedRoute } from '@angular/router'
import { Component, OnInit, OnDestroy } from '@angular/core'
import Validator from '@shared/validatorjs/src/validator'
import { Store, select } from '@ngrx/store'
import FormTrait from 'src/app/traits/form.trait'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css'],
})
export class PasswordResetComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  private state$: Subscription
  public token: string

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token')
    this.state$ = this.store
      .pipe(select(getPasswordResetState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.store.dispatch(new LogoutRequest(false))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      email: 'required|email',
      password: 'required|min:10',
      passwordConfirm: 'required|same:password',
    }

    const validator = new Validator(
      {
        email: data.get('email'),
        password: data.get('password'),
        passwordConfirm: data.get('passwordConfirm'),
      },
      rules,
    )

    validator.setAttributeNames({
      passwordConfirm: 'password confirmation',
    })

    return validator
  }

  public handleFieldChange(e: any): void {
    this.store.dispatch(
      new UpdateField(e.target.name, e.target.value, 'passwordReset.data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(e.target.name),
        'passwordReset',
      ),
    )
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new PasswordResetRequest({ token: this.token, ...payload }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'passwordReset',
        ),
      )
    }
  }
}
